export enum AppStateEnum {
  Booting = 'booting',
  ReadyToStart = 'readyToStart',
  Playing = 'playing',
  Writing = 'writing',
  Recording = 'recording',
  Evaluating = 'evaluating',
  AwaitingTap = 'awaitingTap',
  ReceivingDrawing = 'receivingDrawing',
  EvaluatingDrawing = 'evaluatingDrawing',
  Correct = 'correct',
  AssumeCorrect = 'assumeCorrect',
  Incorrect = 'incorrect',
  Retry = 'retry',
  ReadyForNextStep = 'readyForNextStep',
  MoveToNextStep = 'moveToNextStep',
  Helping = 'helping',
  CollectingFeedback = 'collectingFeedback',
  CollectingParentInfo = 'collectingParentInfo',
  Aborting = 'aborting',
}
